
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/federal/update",
      function () {
        return require("private-next-pages/advocacy/federal/update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/federal/update"])
      });
    }
  